import type { ReactNode } from 'react';
import { EmptyState } from '../components/states';

/**
 * Каркас Inspector — постоянная третья зона desktop (канон Claude Design):
 * 300px · #f6f7f8 · padding 22/20; шапка = категория (10px uppercase) + ✕.
 * Содержимое приходит через InspectorContext (show()); без выбора — пустое состояние.
 * <1180 — drawer, <768 — bottom-sheet (shell.css).
 */
export function Inspector({
  open,
  onClose,
  category,
  children,
}: {
  open: boolean;
  onClose: () => void;
  category?: string;
  children?: ReactNode;
}) {
  return (
    <aside
      className={`inspector${open ? ' is-open' : ''}`}
      aria-label="Инспектор"
      aria-hidden={!open}
    >
      <div className="inspector__header">
        <span className="inspector__category">{category ?? 'Инспектор'}</span>
        <button type="button" className="inspector__close" onClick={onClose} aria-label="Скрыть инспектор" title="Скрыть">
          ✕
        </button>
      </div>
      <div className="inspector__body">
        {children ?? (
          <EmptyState
            title="Объект не выбран"
            text="Выберите строку в таблице или объект на экране — здесь появятся его свойства и действия."
          />
        )}
      </div>
    </aside>
  );
}
